import React from "react";
import { PullOutBlocksPanel, IPullOutBlocksPanelProps } from "../../../components/panels/PullOutBlocksPanel";
import { IContentfulBackgroundColour } from "../../../types/IContentfulBackgroundColour";

export type GetPullOutBlocksPanelProps =
  IPullOutBlocksPanelProps & { id: string, backgroundColour: IContentfulBackgroundColour };

export const getPullOutBlocksPanel = ({
  id,
  title,
  variant,
  headerAnchor,
  backgroundColour,
  content,
  blocks,
  callToActions,
  version,
}: GetPullOutBlocksPanelProps) => (
  <PullOutBlocksPanel
    title={title}
    key={id}
    variant={variant}
    headerAnchor={headerAnchor}
    bgColour={backgroundColour}
    content={content}
    blocks={blocks}
    callToActions={callToActions}
    version={version}
  />
);
